export const cookies = {
	currentAppType: 'currentAppType',
	currentDisplayBy: 'currentDisplayBy',
	issuesSort: 'issuesSort',
	locationPath: 'locationPath',
	selectedAgency: 'selectedAgency',
	selectedFiscalYear: 'selectedFiscalYear',
	selectedLineItem: 'selectedLineItem',
	selectedSubCommittee: 'selectedSubCommittee',
};

export function createCookie(name,value,days) {
	let expires = "";
	if (days) {
		let date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		expires = "; expires="+date.toUTCString();
	}
	document.cookie = name+"="+value+expires+"; path=/";
}

export function readCookie(name) {
	let nameEQ = name + "=";
	let ca = document.cookie.split(';');
	for(let i=0;i < ca.length;i++) {
		let c = ca[i];
		while (c.charAt(0)===' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

/**
 * Check to see if the cookie is valid
 * @param name Name of the cookie
 * @param data Array of object with possible values [{id: x, value: y}]
 * @return {string}
 */
export function verifyCookie(name, data) {
	let dataToTest = data && data.length > 0 ? data : [{value: undefined}];
	let cookie = readCookie(name);
	cookie = cookie ? cookie.split(',') : cookie;
	let value, verify = true;
	if(cookie) {
		for (let i = 0; i < cookie.length; i++) {
			if(!dataToTest.find(item => (item.value === cookie[i]))){
				verify = false;
				break;
			}
		}
		value = verify ? cookie : [dataToTest[0].value];
	} else {
		value = [dataToTest[0].value];
	}
	/* Update the cookie */
	createCookie(name, value.join(), 365);
	return value;
}

export function eraseCookie(name) {
	createCookie(name,"",-1);
}
